import boxShadows from "assets/theme/box-shadow.js";
import hexToRgb from "assets/theme/hex-to-rgb.js";

const componentStyles = (theme) => ({
  cardRoot: {
    display: "flex",
    //boxShadow: boxShadows.boxShadow + "!important",
    [theme.breakpoints.up("xl")]: {
      maxWidth:"80vw",
    },
  },
  cardRootTranslucent: {
    backgroundColor: theme.palette.transparent.main,
  },
  cardRootStripped: {
    "& tbody tr:nth-child(odd)": {
      backgroundColor: "rgba(" + hexToRgb(theme.palette.gray[100]) + ", 0.3)",
    },
  },
  cardRootCheckboxColors: {
    "& tbody tr:nth-child(1)": {
      backgroundColor: theme.palette.success.tableLight,
      "&:hover": {
        backgroundColor: theme.palette.success.tableLightHover,
      },
    },
    "& tbody tr:nth-child(3)": {
      backgroundColor: theme.palette.warning.tableLight,
      "&:hover": {
        backgroundColor: theme.palette.warning.tableLightHover,
      },
    },
  },
  cardRootDark: {
    backgroundColor: theme.palette.dark.main,
    "& *": {
      color: theme.palette.white.main,
    },
    "& $tableCellRoot, & $tableRoot": {
      color: theme.palette.white.main,
      borderColor: theme.palette.dark.tableBorder,
    },
    "& $tableCellRootHead": {
      color: theme.palette.dark.tableHeadColor,
      backgroundColor: theme.palette.dark.tableHeadBgColor,
    },
  },
  cardHeaderRoot: {
    backgroundColor: "initial",
  },
  cardActionsRoot: {
    paddingBottom: "1.5rem!important",
    paddingTop: "1.5rem!important",
    borderTop: "0!important",
  },
  containerRoot: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "30px",
      paddingRight: "30px",
    },
  },
  boxButtonsHeader:{
    justifyContent:"flex-end",
    display:"flex",
    flexWrap:"wrap",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0.8rem",
      justifyContent:"flex-start",
    },
  },
  tableRoot: {
    marginBottom: "0!important",
    maxHeight: "33rem",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: theme.palette.background.default,
      "& > .MuiTableCell-root": {
        color: theme.palette.bsColors.MainBlue,
        //fontWeight:"600"
      }
    },
    
  },
  tableCellRoot: {
    verticalAlign: "middle",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    borderTop: "0",
    overflow:"hidden",
    maxWidth:"15rem",
    fontSize: theme.typography.h5.fontSize,
  },
  tableCellRootHead: {
    backgroundColor: theme.palette.gray[100],
    color: theme.palette.gray[600],
    fontSize: theme.typography.h6.fontSize,
    position:"sticky",
    zIndex: 3,
    "&:first-child": {
      zIndex: 10,
    },
  },
  tableCellRootBodyHead: {
    textTransform: "unset!important",
    fontSize: ".8125rem",
  },
  linearProgressRoot: {
    height: "3px!important",
    width: "120px!important",
    margin: "0!important",
  },
  bgGradientError: {
    background:
      "linear-gradient(87deg," +
      theme.palette.error.main +
      ",#f56036)!important",
  },
  bgGradientSuccess: {
    background:
      "linear-gradient(87deg," +
      theme.palette.success.main +
      ",#2dcecc)!important",
  },
  bgGradientPrimary: {
    background:
      "linear-gradient(87deg," +
      theme.palette.primary.main +
      ",#825ee4)!important",
  },
  bgGradientInfo: {
    background:
      "linear-gradient(87deg," +
      theme.palette.info.main +
      ",#1171ef)!important",
  },
  bgGradientWarning: {
    background:
      "linear-gradient(87deg," +
      theme.palette.warning.main +
      ",#fbb140)!important",
  },
  bgPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  bgPrimaryLight: {
    backgroundColor: theme.palette.primary.light,
  },
  bgError: {
    backgroundColor: theme.palette.error.main,
  },
  bgErrorLight: {
    backgroundColor: theme.palette.error.light,
  },
  bgWarning: {
    backgroundColor: theme.palette.warning.main,
  },
  bgWarningLight: {
    backgroundColor: theme.palette.warning.light,
  },
  bgInfo: {
    backgroundColor: theme.palette.info.main,
  },
  bgInfoLight: {
    backgroundColor: theme.palette.info.light,
  },
  bgSuccess: {
    backgroundColor: theme.palette.success.main,
  },
  verticalAlignMiddle: {
    verticalAlign: "middle",
  },
  avatarRoot: {
    width: "36px",
    height: "36px",
    fontSize: ".875rem",
  },
  companyLogo: {
    width: "20px",
    height: "20px",
    fontSize: ".875rem",
  },
  anchorStyles: {
    fontWeight: "600",
  },
  textUppercase: {
    textTransform: "uppercase",
  },
  buttonRootWhite: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.white.main,
    borderColor: theme.palette.white.main,
    "&:hover": {
      backgroundColor: theme.palette.white.main,
      borderColor: theme.palette.white.main,
      color: theme.palette.dark.main,
    },
  },
  buttonRoot: {
    marginLeft: "0px",
    marginRight: "10px",
    color: theme.palette.bsColors.MainBlue,
    backgroundColor: theme.palette.white.main,
    borderColor: theme.palette.bsColors.GlobalWhite,
    fontSize: theme.typography.h5.fontSize,
    "&:hover": {
      backgroundColor: theme.palette.gray[100],
      borderColor: theme.palette.gray[100],
      color: theme.palette.bsColors.MainBlue,
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: "10px",
      marginRight: "0px",
    },
  },
  buttonRootSelected: {
    marginLeft: "0px",
    marginRight: "10px",
    color: theme.palette.white.main,
    backgroundColor: theme.palette.bsColors.MainBlue,
    borderColor: theme.palette.bsColors.MainBlue,
    fontSize: theme.typography.h5.fontSize,
    "&:hover": {
      backgroundColor: theme.palette.bsColors.MainBlue,
      borderColor: theme.palette.bsColors.MainBlue,
      color: theme.palette.white.main,
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: "10px",
      marginRight: "0px",
    },
  },
  tableCellRootPositive: {
    verticalAlign: "middle",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    borderTop: "0",
    color: theme.palette.bsColors.NumberGreen,
  },
  tableCellRootNegative: {
    verticalAlign: "middle",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    borderTop: "0",
    color: theme.palette.bsColors.NumberRed,
  },
  avatarRootRisk: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk0,
  },
  avatarRootRisk0: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk0,
  },
  avatarRootRisk1: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk1,
  },
  avatarRootRisk2: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk2,
  },
  avatarRootRisk3: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk3,
  },
  avatarRootRisk4: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk4,
  },
  avatarRootRisk5: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk5,
  },
  avatarRootRisk6: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk6,
  },
  avatarRootRisk7: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk7,
  },
  avatarRootRisk8: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk8,
  },
  avatarRootRisk9: {
    width: "30px",
    height: "30px",
    fontWeight: "700",
    fontSize: theme.typography.h5.fontSize,
    backgroundColor: theme.palette.bsColors.Risk9,
  },
});

export default componentStyles;
